// Click btn expand
const expandBtns = document.querySelectorAll('[data-js-expand]');

if (0 != expandBtns.length) {
  [].forEach.call(expandBtns, (btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const relatedTooglePanelId = btn.dataset.jsExpand;
      const relatedTooglePanel = document.querySelector('[data-js-expanded="' + relatedTooglePanelId +'"]');

      if(!relatedTooglePanel.classList.contains("is-open")) {
        // Adding style and aria to expand div
        relatedTooglePanel.classList.add('is-open');
        relatedTooglePanel.setAttribute('aria-hidden', "false");

        // Set style and aria on related expand btn
        btn.setAttribute("aria-expanded", "true");
        btn.classList.add('is-active');
      }
    });
  })
}
